import { render, staticRenderFns } from "./ShengXiaoFenXi.vue?vue&type=template&id=29f7e124&scoped=true&"
import script from "./ShengXiaoFenXi.vue?vue&type=script&lang=js&"
export * from "./ShengXiaoFenXi.vue?vue&type=script&lang=js&"
import style0 from "./ShengXiaoFenXi.vue?vue&type=style&index=0&id=29f7e124&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f7e124",
  null
  
)

export default component.exports